import { memo } from "react";
import { LayoutGrid, Type, Link2 } from "lucide-react";

const QUESTION_TYPES = [
    { id: 'qcm', label: 'QCM', icon: LayoutGrid },
    { id: 'texte', label: 'Saisie', icon: Type },
    { id: 'association', label: 'Association', icon: Link2 },
];

function QuestionTypeSelector({ value, onChange, disabled = false }) {
    return (
        <div className="flex flex-wrap items-center gap-1.5 px-3 sm:px-6 py-2 sm:py-2.5 bg-gray-50 border-b border-gray-100">
            {QUESTION_TYPES.map(({ id, label, icon: Icon }) => {
                const isActive = value === id;
                return (
                    <button
                        key={id}
                        type="button"
                        onClick={() => onChange(id)}
                        disabled={disabled}
                        className={`flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-4 py-1.5 rounded-full text-[11px] sm:text-xs font-medium transition-all duration-150 border-[1.5px] ${
                            isActive
                                ? 'border-blue-900 bg-blue-50 text-blue-900'
                                : 'border-transparent text-gray-500 hover:bg-white'
                        } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                    >
                        <Icon size={13} className="sm:w-3.5 sm:h-3.5" />
                        {label}
                    </button>
                );
            })}
        </div>
    );
}

export default memo(QuestionTypeSelector);
